import React from "react";
import classNames from "classnames";
import { ReactComponent as InfoIcon } from "../../../images/icons/elements/info-circle.svg";

interface InfoBoxProps {
  message: string | React.ReactElement;
  className?: string;
}

const InfoBox: React.FC<InfoBoxProps> = ({ message, className }) => {
  return (
    <div className={classNames("button-settings__notice", className)}>
      <div className="button-settings__icon-wrapper">
        <InfoIcon />
      </div>
      <span className="button-settings__notice-msg">{message}</span>
    </div>
  );
};

export default InfoBox;
